import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import type { SupportedLocale } from 'lumen/services/dates';
import { PARTIAL_DATE_FORMATS } from 'lumen/utils/constants/general-constants';

/**
 * Formats the date based on locale
 * @param  { dayjs } date      : the date to be formatted
 * @param  { string } format   : the format
 * @return { SafeString }      : the formatted date
 */
export default function formatLocalDate(date: Dayjs, format?: string): string {
  const locale = dayjs().locale() as SupportedLocale;
  const localisedFormat =
    format ?? PARTIAL_DATE_FORMATS[locale].WEEKDAY_AND_MONTH_AND_DAY_SHORT;

  return date.format(localisedFormat);
}
